<template>
  <div v-if="serviceTermination" id="t-home-component" :class="componentClassName"></div>
  <div v-else id="t-home-component" :class="componentClassName">
    <a-page-heading>ホーム</a-page-heading>

    <div class="t-home__content">
      <div class="t-home__content-col">
        <m-card-list icon="phone-call-history" title="発着信履歴">
          <template #filter>
            <m-card-filter>
              <div class="m-card-filter__input">
                <a-text-field
                  id="call-history-search-input"
                  ref="callHistorySearchInput"
                  v-model="searchInput"
                  type="search"
                  placeholder="検索"
                  :maxlength="selMaxLength"
                  @input="searchChange"
                  @focus="searchFocus"
                  @keypress.enter="handleCallHistorySearchInput"
                />
              </div>
              <!-- <div class="m-card-filter__select">
                <a-select-field
                  v-model="currentCallHistoryStatus"
                  :options="callHistoryStatusFilterOptions"
                  @change="selectChange"
                >
                </a-select-field>
              </div> -->
            </m-card-filter>
          </template>
          <template #default>
            <template v-for="item in callHistoryList" :key="item.log_id">
              <a-list-item
                :id="item.log_id ? item.log_id.toString() : ''"
                :variant="item.contact_id ? 'alphanumeric' : null"
                :label="item.contact_id ? item.name : item.phone_number"
                :label-color="item.status === 'missed' ? '#ee3848' : '#3e3e3e'"
                :sublabel="item.datetime"
                :icon="getCallHistoryIcon(item)"
                :icon-color="item.status === '不在着信' ? 'red' : 'black'"
                :has-indicator="item.new"
                indicator-color="#ee3848"
                @click="handleCallHistoryItemClick(item.log_id)"
              />
            </template>
          </template>
        </m-card-list>
      </div>
      <div class="t-home__content-col">
        <m-card-list icon="list" title="連絡先">
          <template #filter>
            <m-card-filter>
              <div class="m-card-filter__input">
                <a-text-field
                  id="contact-search-input"
                  ref="contactSearchInput"
                  v-model="contactSearchInput"
                  type="search"
                  placeholder="検索"
                  :maxlength="selMaxLength"
                  @input="searchContactChange"
                  @focus="searchContactFocus"
                  @keypress.enter="handleContactSearchInput"
                />
              </div>
              <!-- <div class="m-card-filter__button">
                <a-button variant="icon" icon="plus" icon-color="white" color="primary" @click="addClick" />
              </div> -->
            </m-card-filter>
          </template>
          <template #default>
            <template v-for="group in contactList" :key="group.group_id">
              <m-list-group :label="group.name">
                <template v-for="item in group.items" :key="item.contact_id">
                  <a-list-item
                    :id="item.contact_id ? item.contact_id.toString() : ''"
                    size="small"
                    :label="item.name"
                    @click="handleContactItemClick(item)"
                  />
                </template>
              </m-list-group>
            </template>
          </template>
        </m-card-list>
      </div>
      <div class="t-home__content-col t-home__content-col--phone-dial">
        <!-- clientListが空欄の場合、o-phone-dialを描画する -->
        <o-phone-dial
          v-if="clientList.length == 0"
          :enable-keyboard="false"
          :available-numbers="clientList"
          :selected-number="currentClient ? currentClient.value : ''"
          :input-number="inputNumber"
          @call="handleCallClickButton"
          @update:current-number="handleNumberChange"
        />
        <!-- clientListが空欄でない場合、o-phone-dialを再度描画する -->
        <o-phone-dial
          v-else-if="clientList.length > 0"
          :enable-keyboard="false"
          :available-numbers="clientList"
          :selected-number="currentClient ? currentClient.value : ''"
          :input-number="inputNumber"
          @call="handleCallClickButton"
          @update:current-number="handleNumberChange"
        />
      </div>
    </div>
    <!-- clientListが空欄の場合、o-phone-dial-windowを描画する -->
    <o-phone-dial-window
      v-if="clientList.length == 0"
      :enable-keyboard="false"
      :available-numbers="clientList"
      :selected-number="currentClient ? currentClient.value : ''"
      :input-number="inputNumber"
      @call="handleCallClickButton"
      @update:current-number="handleNumberChange"
    />
    <!-- clientListが空欄でない場合、o-phone-dial-windowを再度描画する -->
    <o-phone-dial-window
      v-else-if="clientList.length > 0"
      :enable-keyboard="false"
      :available-numbers="clientList"
      :selected-number="currentClient ? currentClient.value : ''"
      :input-number="inputNumber"
      @call="handleCallClickButton"
      @update:current-number="handleNumberChange"
    />
    <o-outgoing-call-modal
      :modal-visible="outgoingModalVisible"
      :available-numbers="clientList"
      :selected-number="currentClient ? currentClient.value : ''"
      :title="selectedClientTitle"
      :handle-modal-close="handleOutgoingModalClose"
      :is-calling="currentIsCalling"
      :current-user-info="currentUserInfo"
      :current-phone-number="currentPhoneNumber"
      @update:current-number="handleNumberChange"
      @call="handleCall"
      @hangup="hangUpClick"
      @error:phone-number-suspended="showSuspendedNumber"
      @show-error-modal="showErrorModal"
    />
    <teleport to="body">
      <o-modal
        v-if="currentCallHistoryData"
        id="home_callHistoryModal"
        v-model:visible="callHistoryDialogVisible"
        class="o-modal-call-history"
        footer-variant="primary"
        width="568px"
        title-icon="phone-call-history"
        title="発着信履歴詳細"
        :footer-shadow="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        @close="handleHistoryDialogClose"
      >
        <a-summary-item-header text="相手先情報">
          <div class="o-modal-call-history__list-header-action">
            <a-button
              id="edit-contact-button"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              icon="edit"
              label="編集"
              @click="handleEditContact"
            />
          </div>
        </a-summary-item-header>
        <m-data-list>
          <a-data-list-item align="right" label="氏名">{{ currentCallHistoryData.contact.name }}</a-data-list-item>
          <a-data-list-item align="right" label="電話番号">{{
            currentCallHistoryData.contact.phone_number
          }}</a-data-list-item>
          <a-data-list-item align="right" label="メールアドレス">{{
            currentCallHistoryData.contact.email
          }}</a-data-list-item>
          <a-data-list-item align="right" label="会社名">{{
            currentCallHistoryData.contact.company_name
          }}</a-data-list-item>
          <a-data-list-item align="right" label="住所">{{
            currentCallHistoryData.contact.street_address
          }}</a-data-list-item>
        </m-data-list>
        <a-summary-item-header text="着信内容" />
        <m-data-list>
          <a-data-list-item align="right" label="応対者">{{ currentCallHistoryData.content.agent }}</a-data-list-item>
          <a-data-list-item align="right" label="タグ">{{ currentCallHistoryData.content.tag }}</a-data-list-item>
          <a-data-list-item align="right" label="実通話時間">{{
            currentCallHistoryData.content.talk_time
          }}</a-data-list-item>
          <a-data-list-item align="right" label="課金時間">{{
            currentCallHistoryData.content.billing_time
          }}</a-data-list-item>
          <a-data-list-item align="right" label="メモ" vertical-align="top" paragraph>
            <a-text>{{ currentCallHistoryData.content.memo }}</a-text>
            <m-button-container variant="horizontal" class="o-modal-call-history__action-button">
              <a-button
                id="edit-memo-button"
                :inline="true"
                variant="round"
                color="grey"
                size="small"
                icon="edit"
                label="編集"
                @click="handleEditMemoClick"
              />
            </m-button-container>
          </a-data-list-item>
          <a-data-list-item align="right" label="通話録音" vertical-align="top" paragraph>
            <m-audio-player :audio-url="currentCallHistoryData.content.recording_url" />
            <m-button-container variant="horizontal" class="o-modal-call-history__action-button">
              <a-button
                id="edit-record-button"
                :inline="true"
                variant="round"
                color="grey"
                size="small"
                icon="edit"
                label="テキスト化"
                @click="handleEditRecordingClick"
              />
              <a-button
                id="download-record-button"
                :inline="true"
                variant="round"
                color="grey"
                size="small"
                icon="download"
                label="ダウンロード"
                @click="handleDownloadRecordingClick"
              />
            </m-button-container>
          </a-data-list-item>
        </m-data-list>
        <template #footer>
          <a-button
            id="call-button"
            variant="round"
            color="primary"
            label="発信"
            icon="phone-outgoing-call"
            icon-color="white"
            size="small"
            @click="handleCallClickButton"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        v-if="currentContactData"
        id="home_contactModal"
        v-model:visible="contactDialogVisible"
        class="o-modal-home-contact"
        footer-variant="primary"
        width="568px"
        title-icon="list"
        title="発着信履歴詳細"
        :footer-shadow="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        @close="handleHistoryDialogClose"
      >
        <template #title>
          連絡先情報
          <a-frequently-used-contact-button
            :active="currentContactData.isFrequentlyUsedContact"
            @click="handleFrequentlyContactClick"
            @change="handleFrequentlyContactChange"
          />
        </template>

        <a-summary-item-header class="o-modal-home-contact__caller-information" text="着信元情報">
          <div class="o-modal-home-contact__caller-information-control">
            <a-button
              id="edit-caller-info-button"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              icon="edit"
              label="編集"
              @click="handleEditCallerInformation"
            />
            <a-button
              id="edit-row-contact-remove-button"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              icon="trash"
              label="削除"
              @click="handleRowContactRemove"
            />
          </div>
        </a-summary-item-header>
        <m-data-list
          variant="long"
          :data="currentContactData.callerInformationData"
          class="o-modal-home-contact__caller-information-data"
          align-right
        />

        <a-summary-item-header class="o-modal-home-contact__call-history" text="発着信履歴">
          <div class="o-modal-home-contact__call-history-control">
            <a-button
              id="contact-view-more-button"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              label="もっと見る"
              @click="handleContactViewMore"
            />
          </div>
        </a-summary-item-header>

        <ul class="o-modal-home-contact__call-history-list">
          <li
            v-for="(item, key) in currentContactData.callHistoryData"
            :key="key"
            class="o-modal-home-contact__call-history-item"
          >
            <span>
              <a-icon :icon="getContactCallStatus(item.status)" />
              {{ item.caller }}
            </span>
            <span>{{ item.time }}</span>
          </li>
        </ul>

        <template #footer>
          <a-button
            id="call-button"
            variant="round"
            color="primary"
            label="発信"
            icon="phone-outgoing-call"
            icon-color="white"
            size="small"
            @click="handleCallClickButton"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="home_removeContactModal"
        v-model:visible="removeContactDialogVisible"
        class="o-modal-remove-contact-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        @close="handleCancelRemoveContact"
      >
        <a-text :center="true">
          <!-- eslint-disable -->
        <span v-html="removeContactConfirmationMessageText" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="cancel-remove-contact-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCancelRemoveContact"
          />
          <a-button
            id="confirm-remove-contact-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleConfirmRemoveContact"
          />
        </template>
      </o-modal>
    </teleport>

    <teleport to="body">
      <o-modal
        id="home_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
        <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="close-modal-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MCardList from '@/components/molecules/card-list';
import OPhoneDial from '@/components/organisms/phone-dial';
import MCardFilter from '@/components/molecules/card-filter';
import ATextField from '@/components/atoms/text-field';
import ASelectField from '@/components/atoms/select-field';
import AListItem from '@/components/atoms/list-item';
import MListGroup from '@/components/molecules/list-group';
import AButton from '@/components/atoms/button';
import OPhoneDialWindow from '@/components/organisms/phone-dial-window';
import OModal from '@/components/organisms/modal';
import ASummaryItemHeader from '@/components/atoms/summary-item-header';
import MDataList from '@/components/molecules/data-list';
import ADataListItem from '@/components/atoms/data-list-item';
import MButtonContainer from '@/components/molecules/button-container';
import MAudioPlayer from '@/components/molecules/audio-player';
import AText from '@/components/atoms/text';
import AFrequentlyUsedContactButton from '@/components/atoms/frequently-used-contact-button';
import AIcon from '@/components/atoms/icon';
import OOutgoingCallModal from '@/components/organisms/outgoing-call-modal';
import { debounce } from 'lodash';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { chkTrialCompanyID } from '@/libs/utils';

export default {
  name: 't-home',
  components: {
    APageHeading,
    MCardList,
    OPhoneDial,
    MCardFilter,
    ATextField,
    //ASelectField,
    AListItem,
    MListGroup,
    AButton,
    OPhoneDialWindow,
    OModal,
    ASummaryItemHeader,
    MDataList,
    ADataListItem,
    MButtonContainer,
    MAudioPlayer,
    AText,
    AFrequentlyUsedContactButton,
    AIcon,
    OOutgoingCallModal,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    currentUserInfo: {
      type: Object,
      default: null,
    },
    // availableNumbers: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // selectedNumber: {
    //   type: String,
    //   default: '',
    // },
    callHistoryStatusFilterOptions: {
      type: Array,
      default: new Array(0),
    },
    callHistoryStatus: {
      type: String,
      default: 'all',
    },
    // callHistoryList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // contactList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    clientList: {
      type: Array,
      default: new Array(0),
    },
    contactInformation: {
      type: Array,
      default: new Array(0),
    },
    handleCallHistorySearchChange: {
      type: Function,
      default: () => {},
    },
    handleCallHistoryStatusFilterChange: {
      type: Function,
      default: () => {},
    },
    handleContactSearchChange: {
      type: Function,
      default: () => {},
    },
    // handleAddContactClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCall: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNumberChange: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCallHistoryItemClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleContactItemClick: {
    //   type: Function,
    //   default: () => {},
    // },
    clientName: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      required: true,
    },
    // call history dialog
    currentCallHistoryData: {
      type: Object,
      default: null,
    },
    handleCallClick: {
      type: Function,
      default: () => {},
    },
    handleEditContact: {
      type: Function,
      default: () => {},
    },
    handleEditMemoClick: {
      type: Function,
      default: () => {},
    },
    handleEditRecordingClick: {
      type: Function,
      default: () => {},
    },
    handleDownloadRecordingClick: {
      type: Function,
      default: () => {},
    },
    // contact dialog
    removeContactConfirmationMessageText: {
      type: String,
      default: null,
    },
    currentContactData: {
      type: Object,
      default: null,
    },
    handleFrequentlyContactClick: {
      type: Function,
      default: () => {},
    },
    handleFrequentlyContactChange: {
      type: Function,
      default: () => {},
    },
    handleEditCallerInformation: {
      type: Function,
      default: () => {},
    },
    handleDeleteCallerInformation: {
      type: Function,
      default: () => {},
    },
    handleContactViewMore: {
      type: Function,
      default: () => {},
    },
    //Outoging-modal
    isCalling: {
      type: Boolean,
      default: false,
    },
    hangUpClick: {
      type: Function,
      default: () => {},
    },
  },
  emits: ['call', 'update:currentNumber', 'update:currentClientList'],
  data() {
    return {
      selectedNumber: '',
      currentCallHistoryStatus: 'all',
      searchInput: '',
      contactSearchInput: '',
      callHistoryDialogVisible: false,
      contactDialogVisible: false,
      removeContactDialogVisible: false,
      availableNumbers: [],
      callHistoryList: [],
      contactList: [],
      // selectedNumber: '',
      testNumber: ``,
      log_id: 0,
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,

      //outgoing-modal
      outgoingModalVisible: false,
      currentIsCalling: false,
      selectedClientTitle: '',
      currentPhoneNumber: '',
      currentClient: {},
      inputNumber: '',
      selMaxLength: '20',

      // SalesforceのClickToDial用電話番号
      sfOutboundPhoneNumber: null,

      sfAvailable: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-home');
      return `${baseClassName} ${this.class}`.trim();
    },
    serviceTermination() {
      return this.$store.state.user.serviceTermination;
    },
  },
  watch: {
    callHistoryStatus(val) {
      this.currentCallHistoryStatus = val;
    },
    currentCallHistoryData(val) {
      if (val) {
        this.callHistoryDialogVisible = true;
      }
    },
    currentContactData(val) {
      if (val) {
        this.contactDialogVisible = true;
      }
    },
    isCalling(val) {
      if (!val) {
        //キャンセル
        this.handleOutgoingModalClose();
      } else {
        //発信中
        this.currentIsCalling = true;
      }
    },
    clientList(val) {
      if (val.length && (!this.currentClient || (this.currentClient && !this.currentClient.value))) {
        this.currentClient = val[0];
        this.handleNumberChange(this.currentClient.value);
      }
    },
  },
  created() {
    // サービス終了の場合は何もしない
    if (this.serviceTermination) return;
    // 発着信履歴の情報を取得する
    this.getCallHistorylist();
    // 連絡先の情報を取得する
    this.getContactlist();
  },
  async mounted() {
    // サービス終了の場合は何もしない
    if (this.serviceTermination) return;
    // #5897
    if (this.clientList.length > 0) {
      this.currentClient = this.clientList[0];
    }

    if (this.callHistoryStatus) {
      this.currentCallHistoryStatus = this.callHistoryStatus;
    }
    if (this.currentCallHistoryData) {
      this.callHistoryDialogVisible = true;
    }
    if (this.currentContactData) {
      this.contactDialogVisible = true;
    }
    if (this.$route.query.contactID) {
      //console.log(this.$route.query.contactID);
      // this.handleNumberChange('0');
      // this.selectedNumber = this.$route.query.contactID;
    }

    this.setViewport();

    // Salesforce連携設定ONOFF取得
    await this.postRequest('/callLogClient/getSfPopupAvailable', {})
      .then(e => {
        if (e.status === 'success') {
          this.sfAvailable = e.data.companyInfo.sfAvailable;
        }
      })
      .catch(err => {
        console.error(err);
      });
    // ClickToDialの電話番号を確認
    if (this.sfAvailable === true) {
      const sfPhoneNumber = localStorage.getItem('sfClickToDial');
      if (sfPhoneNumber) {
        this.sfOutboundPhoneNumber = sfPhoneNumber.replace('+81', '0');
        setTimeout(() => {
          this.handleCallClickButton(this.sfOutboundPhoneNumber);
          localStorage.removeItem('sfClickToDial');
        }, 1000);
      }
    } else {
      localStorage.removeItem('sfClickToDial');
    }
  },
  methods: {
    getCallHistoryIcon(item) {
      if (item.voicemessageFlag === true) {
        return 'phone-voicemail';
        //#4060 あふれ呼用アイコンは使わない
        //} else if (item.overFlowFlag === true) {
        //return 'phone-over-flow';
      } else {
        if (item.status === '不在着信') {
          return 'phone-missed-call';
        } else if (item.status === '着信') {
          return 'phone-incoming-call';
        } else if (item.status === '内線') {
          return 'phone-extension';
        } else if (item.status === 'アウトバウンド') {
          return 'outbound';
        }
        return 'phone-outgoing-call';
      }
    },
    selectChange(data) {
      this.handleCallHistoryStatusFilterChange({
        status: this.currentCallHistoryStatus,
        value: this.searchInput,
      });
    },
    searchFocus(e) {
      const input = this.$refs.callHistorySearchInput.$el.querySelector('input');
      if (input) {
        input.setSelectionRange(0, input.value.length);
      }
    },
    searchContactFocus(e) {
      const input = this.$refs.contactSearchInput.$el.querySelector('input');
      if (input) {
        input.setSelectionRange(0, input.value.length);
      }
    },
    searchChange: debounce(function (e) {
      this.handleCallHistorySearchChange({
        status: this.currentCallHistoryStatus,
        value: this.searchInput,
      });
    }, 150),
    searchContactChange: debounce(function (e) {
      this.handleContactSearchChange(this.contactSearchInput);
    }, 150),
    addClick() {
      this.handleAddContactClick();
    },
    handleHistoryDialogClose() {
      this.callHistoryDialogVisible = false;
    },
    getContactCallStatus(status) {
      let icon = '';
      switch (status) {
        case 'income':
          icon = 'phone-incoming-call-outline';
          break;
        case 'miss':
          icon = 'phone-missed-call-outline';
          break;
        case 'outcome':
          icon = 'phone-outgoing-call-outline';
          break;
        default:
          break;
      }
      return icon;
    },
    handleRowContactRemove(role, data) {
      this.removeContactDialogVisible = true;
    },
    handleConfirmRemoveContact() {
      this.handleDeleteCallerInformation();
      this.resetContactToRemove();
    },
    handleCancelRemoveContact() {
      this.resetContactToRemove();
    },
    resetContactToRemove() {
      this.removeContactDialogVisible = false;
    },
    // handleCall(value) {
    //   this.$emit('call', value);
    // },
    handleCall(from) {
      let to = '';
      if (this.currentPhoneNumber) {
        to = {
          currentPhoneNumber: this.currentPhoneNumber,
          title: this.selectedClientTitle,
        };
        this.updatePreviousSelectedTelNumber(from);
      }
      this.$emit('call', to, from);
    },
    handleNumberChange(e) {
      const client = this.clientList.find(client => client.value === e);
      this.currentClient = client;
      this.$emit('update:currentNumber', client);
    },
    handleClientListChange(clientList) {
      this.$emit('update:currentClientList', clientList);
    },
    getCallHistorylist() {
      this.postRequest('/callLogClient/getcallhistory')
        .then(e => {
          this.callHistoryList = e.callHistoryList;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('発着信履歴の取得'));
        });
    },
    handleCallHistorySearchInput() {
      this.searchCallHistory(this.searchInput);
    },
    searchCallHistory(phoneNumber) {
      if (!phoneNumber) {
        this.getCallHistorylist();
      }
      if (!this.hasSpecialCharacterInString(phoneNumber)) {
        this.postRequest('/callLogClient/searchcallhistory', { phoneNumber })
          .then(e => {
            this.callHistoryList = e.callHistoryList;
          })
          .catch(() => {
            this.showErrorModal(messageContent.requireTry('発着信履歴の検索'));
          });
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    getContactlist() {
      this.postRequest('/contactlist/getcontactusers')
        .then(e => {
          this.contactList = e.contactList;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('連絡先情報の取得'));
        });
    },
    handleContactSearchInput() {
      // #2809
      this.searctContactlist(this.contactSearchInput.replace(/\t/g, '').replace(/[ 　]+/g, '_'), ``);
    },
    searctContactlist(name) {
      if (!this.hasSpecialCharacterInString(name)) {
        if (!name === '') {
          this.getContactlist();
        }
        this.postRequest('/contactlist/searchcontactlist', { name })
          .then(e => {
            this.contactList = e.contactList;
          })
          .catch(() => {
            this.showErrorModal(messageContent.requireTry('連絡先情報の検索'));
          });
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    handleCallHistoryItemClick(log_id) {
      // this.log_id = log_id;
      // this.testNumber = this.callHistoryList[this.log_id].phone_number;
      // console.log('test: ' + this.testNumber);
      const selectedHistory = this.callHistoryList[parseInt(log_id) - 1];
      if (this.isPhoneNumber(selectedHistory.partner_number)) {
        this.inputNumber = selectedHistory.partner_number;
      } else {
        this.inputNumber = '';
        const client = this.clientList.find(client => client.label === selectedHistory.partner_number);
        if (client) {
          this.currentClient = client;
          this.$emit('update:currentNumber', client);
        }
      }
    },
    handleContactItemClick(contact) {
      if (this.isPhoneNumber(contact.phoneNumber)) {
        this.inputNumber = contact.phoneNumber;
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleOutgoingModalClose() {
      this.outgoingModalVisible = false;
      this.currentIsCalling = false;
      this.currentPhoneNumber = '';
    },
    handleCallClickButton(e) {
      if (e && chkTrialCompanyID(this.companyID)) {
        this.showErrorModal(messageContent.notifyTrialUserCanNotMakeGaiSenCall());
        return;
      }
      this.currentPhoneNumber = e.trim();
      if (this.currentPhoneNumber) {
        //外線情報
        this.selectedClientTitle = '';
        this.postRequest('/home/getcontactdata', { contactID: e, companyID: this.companyID })
          .then(parameters => {
            if (!parameters.data) {
              this.selectedClientTitle = this.currentPhoneNumber;
            } else {
              this.selectedClientTitle = parameters.data.view_name;
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        //内線情報
        this.selectedClientTitle = this.currentClient.label;
      }
      this.outgoingModalVisible = true;
    },
    setViewport() {
      const metalist = document.getElementsByTagName('meta');
      for (let i = 0; i < metalist.length; i++) {
        const name = metalist[i].getAttribute('name');
        if (name && name.toLowerCase() === 'viewport') {
          metalist[i].setAttribute('content', 'width=1280');
          break;
        }
      }
    },
    showSuspendedNumber() {
      this.handleOutgoingModalClose();
      this.showErrorModal(messageContent.notifyPendingPhoneNumber);
    },
    // #2730
    AutoLink(str) {
      const regexp_url = /((https:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
      const regexp_makeLink = function (all, url, href) {
        //console.log('###### all='+all+' ## url='+url+' ## href='+href);
        return (
          '<a href="' +
          href +
          '" target="_blank" rel="noopener noreferrer" class="t-home__notify-message-link">' +
          url +
          '</a>'
        );
      };
      return str.replace(regexp_url, regexp_makeLink);
    },
    updatePreviousSelectedTelNumber(from) {
      this.postRequest('/home/updatePreviousSelectedTelNumber', {
        previousSelectedTelNumber: from,
      })
        .then(res => {
          if (res.status === 'success') {
            return;
          } else {
            throw new Error(messageContent.httpRequestError('/home/updatePreviousSelectedTelNumber'));
          }
        })
        .catch(err => {
          //console.error(err);
        });
    },
  },
};
</script>
